import { useQueryClient } from "@tanstack/react-query";

import { getQueryKey } from "app/modules/api-client";

import { ACTIVATION_OBJECT_QUERY_KEY } from "../../../queries/data/useActivationObjectQuery";
import { ACTIVATION_OBJECTS_QUERY_KEY } from "../../../queries/data/useActivationSetListQuery";
import { GA_DATA_QUERY_KEY } from "../../../queries/googleAnalytics/useGAData";

export const useInvalidateRelatedGaMappingQueries = (activationId: string) => {
    const queryClient = useQueryClient();

    return async () =>
        Promise.all([
            queryClient.invalidateQueries({
                queryKey: getQueryKey({
                    tag: "Activation",
                    methodName: "activationGaMappingDetail",
                    args: [activationId],
                }),
                refetchType: "all",
            }),
            // activationSet data
            queryClient.invalidateQueries({
                queryKey: getQueryKey({
                    tag: "Activation",
                    methodName: "userdataActivationDetail",
                    args: [activationId],
                }),
                refetchType: "all",
            }),
            queryClient.invalidateQueries({
                queryKey: [ACTIVATION_OBJECT_QUERY_KEY, activationId],
                refetchType: "all",
            }),
            // activationSet data in benchmark, should be unified with ACTIVATION_OBJECT_QUERY_KEY using generated SDK
            queryClient.invalidateQueries({
                queryKey: ["userdata", "activation", activationId],
                refetchType: "all",
            }),
            // homepage projects list data
            queryClient.invalidateQueries({
                queryKey: [ACTIVATION_OBJECTS_QUERY_KEY],
                refetchType: "all",
            }),
            // GaWidget data
            queryClient.invalidateQueries({
                queryKey: [GA_DATA_QUERY_KEY, activationId],
                refetchType: "all",
            }),
        ]);
};
